import { useState } from "react";
import { useDispatch } from "react-redux";
import { addLike } from "../../features/blog/BlogSlice";

export default function Like({ id, likes }) {
	const dispatch = useDispatch();

	const [likeCount, setLikeCount] = useState(likes);
	const handleLikeIncrement = () => {
		dispatch(addLike({ id, likes: likeCount })).then(
			setLikeCount(likeCount + 1)
		);
	};

	return (
		<button
			onClick={handleLikeIncrement}
			className="like-btn"
			id="lws-singleLinks"
		>
			<i className="fa-regular fa-thumbs-up"></i> {likeCount}
		</button>
	);
}
